/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamImportExamItemBatchMutationRequest,
  PostApiV1ExamImportExamItemBatchMutationResponse,
  PostApiV1ExamImportExamItemBatch400,
  PostApiV1ExamImportExamItemBatch401,
  PostApiV1ExamImportExamItemBatch404,
  PostApiV1ExamImportExamItemBatch500,
} from "../../types/examEvaluationController/PostApiV1ExamImportExamItemBatch.ts";

function getPostApiV1ExamImportExamItemBatchUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/exam/import-exam-item-batch` as const,
  };
  return res;
}

/**
 * @description Importa questões da biblioteca para uma versões de provas (ExamLang), criando cópias vinculadas ao ExamLang informado. Questões já importadas e não canceladas são ignoradas. Quando a questão possui lista de respostas (Escolha Simples ou Múltipla), a lista e seus valores são duplicados para a cópia. Requer que o ExamLang e a empresa da prova sejam acessíveis pelo usuário logado. **(Requer Authorization para autenticação)**
 * @summary Importar questões em lote para uma versão de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/import-exam-item-batch}
 */
export async function postApiV1ExamImportExamItemBatch(
  data?: PostApiV1ExamImportExamItemBatchMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ExamImportExamItemBatchMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamImportExamItemBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamImportExamItemBatch400
      | PostApiV1ExamImportExamItemBatch401
      | PostApiV1ExamImportExamItemBatch404
      | PostApiV1ExamImportExamItemBatch500
    >,
    PostApiV1ExamImportExamItemBatchMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamImportExamItemBatchUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
